import { DateFormat, Group, Icon, Space, Tag, Text } from "components/common"

import cx from "clsx"
import CardTag from "components/common/cardTag/cardTag"
import Recording from "components/common/recording/recording"
import { IconText, TitleDescription } from "components/custom"

import { Col, Row } from "antd"
import { FLagWithText } from "components/common/flagWithText/flagWithText"
import TimeFormat from "components/common/timeFormat/timeFormat"
import { SvgMenuClients } from "components/svg"
import dayjs from "dayjs"
import { t } from "i18next"
import { convertToReadableString, joinBytItems, localisedValue } from "utils"
import theme from "utils/themeVars"
import styles from "./callsTab.module.less"

function CallDetailCard({ callDetail }) {
  const isMeeting = callDetail?.audioAnalysis

  return (
    <div>
      <Group template={"3fr 2fr"} gap="20px" className={cx(styles.outlook, "p-16")}>
        <Space direction="vertical" size={2}>
          <TitleDescription
            title={
              <Space size={8}>
                {callDetail?.phoneCallId ? (
                  callDetail?.callType && (
                    <Icon
                      size="20px"
                      icon={callDetail.callType === "out" ? "IconCallOutgoing" : "IconCallIncoming"}
                      className="vAlignMiddle"
                    />
                  )
                ) : (
                  <SvgMenuClients color={theme["text-color-secondary"]} size="20" />
                )}
                {<Text strong>{isMeeting ? callDetail?.title : callDetail?.userName || callDetail?.staff?.name}</Text>}
                {isMeeting ? (
                  <Tag color={theme["primary-color"]}>{callDetail?.meetingType?.title}</Tag>
                ) : (
                  callDetail?.phoneCallId && (
                    <CardTag
                      title={callDetail?.tagShort}
                      color={callDetail?.tagStyle?.bgColor || callDetail?.tagColor}
                      tooltipTitle={callDetail?.tag?.tooltipTitle || callDetail?.tooltipTitle}
                    />
                  )
                )}
              </Space>
            }
            gapSpace={4}
            description={joinBytItems(
              [
                !isMeeting &&
                  (callDetail?.phoneCallId ? (
                    `Via ${callDetail?.callBy}`
                  ) : (
                    <IconText
                      icon="MdLocationPin"
                      title={convertToReadableString(callDetail?.summary?.meeting?.next_meeting_venue)}
                      iconProps={{
                        size: "1.5em",
                      }}
                      style={{ alignItems: "flex-start", "--typography-color": "#9D9D9D", fontSize: 14, gap: 8 }}
                      titleProps={{ style: { fontSize: 14 } }}
                    />
                  )),
                <DateFormat
                  date={
                    isMeeting
                      ? callDetail?.actualStartTime
                      : callDetail.date || callDetail?.summary?.meeting?.next_meeting_date
                  }
                />,
                <TimeFormat
                  date={dayjs
                    .utc(isMeeting ? callDetail?.actualStartTime : callDetail.time || callDetail?.createdAt)
                    .local()}
                  isTimeOnlyStr
                />,
              ],
              <Icon icon="GoDotFill" size=".7em" color="#D6D6D6" />
            )}
          />
        </Space>
        {isMeeting ? (
          <Row className={styles.productInfoMain}>
            <Col className={styles.productInfo}>
              <small className="gray-800">{t("Host Name")}</small>
              <strong>{localisedValue({ object: callDetail?.organizer, key: "name" })}</strong>
            </Col>
            <Col className={styles.productInfo}>
              <small className="gray-800">{t("Participants")}</small>
              <strong>{callDetail?.attendees?.length}</strong>
            </Col>
            <Col className={styles.productInfo}>
              <small className="gray-800">{t("Meeting Score")}</small>
              <strong>{callDetail?.aiTotalScore}</strong>
            </Col>
          </Row>
        ) : (
          <Space size={2}>
            <TitleDescription
              title={
                <FLagWithText
                  title={callDetail?.client?.country?.name || callDetail?.client?.Country?.name}
                  countryCode={callDetail?.client?.country?.loc_code || callDetail?.client?.Country?.loc_code}
                  infoText={<span>{callDetail?.client?.name}</span>}
                />
              }
              gapSpace={4}
              description={"Client Name"}
            />
          </Space>
        )}
        <div>
          {callDetail?.audioAnalysis?.url && (
            <Recording id="call-detail-card-audio" recordingSrc={callDetail?.audioAnalysis?.url} />
          )}
        </div>
      </Group>
    </div>
  )
}

export default CallDetailCard
